import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
export default {
  data: function data() {
    return {
      searchForm: {
        stationLineId: this.$route.query.stationLineId
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据

      stationForm: {},
      stationDialogVisible: false,
      // 弹窗状态
      subwayList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getSubwayList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getSubwayList: function getSubwayList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getSubwayList({
                id: _this2.$route.query.cityId
              });
            case 1:
              res = _context2.v;
              _this2.subwayList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.updateSubwayStationSort({
                subway_line_id: _this3.searchForm.stationLineId,
                subway_station_id: row.id,
                sort: row.sort
              });
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getSubwayStationList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.stationForm = row;
      this.stationDialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.updateSubwayStation(_this5.stationForm);
            case 1:
              _this5.$message.success("操作成功");
              _this5.stationDialogVisible = false;
              _this5.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};